import React from 'react';
import PropTypes from 'prop-types';
import ErrorBoundary from '../error_boundary_v1';
import SourceRequestsIndex from './index/source_requests_index';

function TopLevelIndex({
 view, publication, showAds, reporterUser, completeProfile, profileLink,
}) {
  return (
    <ErrorBoundary>
      <SourceRequestsIndex
        view={view}
        publication={publication}
        showAds={showAds}
        completeProfile={completeProfile}
        profileLink={profileLink}
        reporterUser={reporterUser}
      />
    </ErrorBoundary>
  );
}

TopLevelIndex.propTypes = {
  view: PropTypes.string,
  publication: PropTypes.string,
  showAds: PropTypes.bool,
  completeProfile: PropTypes.bool,
  profileLink: PropTypes.string,
  reporterUser: PropTypes.number,
};

TopLevelIndex.defaultProps = {
  view: 'all',
  publication: '',
  showAds: false,
  completeProfile: false,
  profileLink: '',
  reporterUser: undefined,
};

export default TopLevelIndex;
